import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstancetfg6b5k18hsf as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance363ajpo4f7xlh as Companion_getInstance_0,
  HeadersBuilder3h7sn3kkvu98m as HeadersBuilder,
} from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { flatten2dh4kibw1u0qq as flatten } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstanceitqdjrwn2jrm as PlatformUtils_getInstance } from '../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { toTypedArray3sl1vhn8ifta0 as toTypedArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_open__qjxcea($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.q54_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().c55_1)) {
    tmp = Companion_getInstance().e55_1;
  } else if (tmp0_subject.equals(Companion_getInstance().b55_1)) {
    tmp = Companion_getInstance().d55_1;
  } else if (tmp0_subject.equals(Companion_getInstance().d55_1) || tmp0_subject.equals(Companion_getInstance().e55_1)) {
    tmp = url.q54_1;
  } else {
    throw UnsupportedOperationException().f1('SOCKS is not a supported protocol');
  }
  this_0.a55(tmp);
  var newUrl = this_0.n37();
  var tmp_0 = newUrl.toString();
  // Inline function 'io.ktor.http.Companion.build' call
  Companion_getInstance_0();
  // Inline function 'kotlin.apply' call
  var this_1 = new (HeadersBuilder())();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = headers.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    this_1.u4o(element.f49_1, element.g49_1);
  }
  var tmp$ret$6 = this_1.n37();
  var tmp_1 = awaitConnection($this, createWebSocket($this, tmp_0, tmp$ret$6), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var socket = tmp_1;
  var messageChannel = Channel(2147483647);
  socket.onmessage = (messageEvent) => {
    var data = messageEvent.data;
    var tmp;
    if (!(data == null)) {
      if (!(data == null) ? typeof data === 'string' : false)
        messageChannel.f1b(data);
      else {
        throw UnsupportedOperationException().f1('' + getKClassFromExpression(data).o1() + ' is currently unsupported');
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
  socket.onclose = (it) => messageChannel.r1b();
  return new (DefaultWebSocketEngine$open$7())(messageChannel, socket);
}
function open($this, url, headers, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea.bind(VOID, $this, url, headers), $completion);
}
function createWebSocket($this, urlString_capturingHack, headers) {
  // Inline function 'kotlin.collections.partition' call
  var this_0 = headers.r4o();
  var first = ArrayList().u2();
  var second = ArrayList().u2();
  var _iterator__ex2g4s = this_0.u1();
  while (_iterator__ex2g4s.v1()) {
    var element = _iterator__ex2g4s.w1();
    if (equals(element, 'sec-websocket-protocol', true)) {
      first.n2(element);
    } else {
      second.n2(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first, second);
  var protocolHeaderNames = _destruct__k2r9zo.df();
  var otherHeaderNames = _destruct__k2r9zo.ef();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().u2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.u1();
  while (_iterator__ex2g4s_0.v1()) {
    var element_0 = _iterator__ex2g4s_0.w1();
    var tmp0_safe_receiver = headers.p4o(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.n2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = flatten(destination);
  var protocols = copyToArray(this_1);
  var tmp;
  if (PlatformUtils_getInstance().c4o_1) {
    var ws_capturingHack = eval('require')('ws');
    var headers_capturingHack = new (DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1())();
    headers.w4o((name, values) => {
      headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    });
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  } else {
    // Inline function 'kotlin.check' call
    if (!otherHeaderNames.s1()) {
      var message = "Apollo: the WebSocket browser API doesn't allow passing headers. Use connectionPayload or other mechanisms.";
      throw IllegalStateException().o(toString(message));
    }
    tmp = new WebSocket(urlString_capturingHack, protocols);
  }
  return tmp;
}
function awaitConnection($this, _this__u8e3s4, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  $l$block: {
    var continuation = cancellable;
    if (continuation.bx()) {
      break $l$block;
    }
    var eventListener = {_v: null};
    var removeEventListeners = () => {
      _this__u8e3s4.removeEventListener('open', eventListener._v);
      _this__u8e3s4.removeEventListener('error', eventListener._v);
      return Unit_instance;
    };
    eventListener._v = (event) => {
      var tmp;
      if (!continuation.bx()) {
        var tmp0_subject = event.type;
        var tmp_0;
        if (tmp0_subject === 'open') {
          var tmp0 = continuation;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = _this__u8e3s4;
          var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
          tmp0.tc(tmp$ret$1);
          tmp_0 = removeEventListeners();
        } else if (tmp0_subject === 'error') {
          var tmp0_0 = continuation;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = IllegalStateException().o(asString($this, event));
          var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0_0.tc(tmp$ret$3);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
    continuation.kz((it) => {
      removeEventListeners();
      var tmp;
      if (!(it == null)) {
        _this__u8e3s4.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    _this__u8e3s4.addEventListener('open', eventListener._v);
    _this__u8e3s4.addEventListener('error', eventListener._v);
  }
  return cancellable.my();
}
function asString($this, _this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().q1();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
  this_0.r1(tmp.stringify(_this__u8e3s4, tmp$ret$2));
  return this_0.toString();
}
var DefaultWebSocketEngine$open$7Class;
function DefaultWebSocketEngine$open$7() {
  if (DefaultWebSocketEngine$open$7Class === VOID) {
    class $ {
      constructor($messageChannel, $socket) {
        this.c6d_1 = $messageChannel;
        this.d6d_1 = $socket;
      }
      i1b($completion) {
        return this.c6d_1.i1b($completion);
      }
      t6c(data) {
        this.d6d_1.send(new Uint8Array(toTypedArray(data.o3x())));
      }
      u6c(string) {
        this.d6d_1.send(string);
      }
      q6() {
        this.d6d_1.close(1000);
        this.c6d_1.r1b();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    DefaultWebSocketEngine$open$7Class = $;
  }
  return DefaultWebSocketEngine$open$7Class;
}
var DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class;
function DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1() {
  if (DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class = $;
  }
  return DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class;
}
var DefaultWebSocketEngineClass;
function DefaultWebSocketEngine() {
  if (DefaultWebSocketEngineClass === VOID) {
    class $ {
      l6c(url, headers, $completion) {
        return open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'DefaultWebSocketEngine', DefaultWebSocketEngine, VOID, VOID, [2, 1]);
    DefaultWebSocketEngineClass = $;
  }
  return DefaultWebSocketEngineClass;
}
//region block: exports
export {
  DefaultWebSocketEngine as DefaultWebSocketEngine2qlkcxmcddkl7,
};
//endregion

//# sourceMappingURL=JsWebSocketEngine.mjs.map
